import React from 'react';
import '../../styles/MisRetiros.css';
import '../../styles/Reportes.css'; // Reutilizamos los estilos de los reportes
import StatusBadge from '../../components/common/StatusBadge.js'; // Importamos el nuevo componente unificado

const MisRetiros = ({ withdrawals }) => {
    return (
        <div className="main-panel">
            <h2 className="section-title">Mis Retiros</h2>
            <p>Aquí puedes ver el historial de todas tus solicitudes de retiro.</p>

            <div className="report-table-container" style={{ marginTop: '2rem' }}>
                <table className="report-table">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Monto Solicitado</th>
                            <th>Comisión (10%)</th>
                            <th>Monto a Recibir</th>
                            <th>Estado</th>
                            <th>Detalles</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withdrawals.length === 0 ? (
                            <tr><td colSpan="6" style={{ textAlign: 'center' }}>No has realizado ninguna solicitud de retiro.</td></tr>
                        ) : (
                            withdrawals.map(req => (
                                <tr key={req.id}>
                                    <td>{req.createdAt?.toDate().toLocaleString('es-ES')}</td>
                                    <td>${req.amount.toFixed(2)}</td>
                                    <td>${(req.fee || 0).toFixed(2)}</td>
                                    <td><strong>${(req.netAmount || 0).toFixed(2)}</strong></td>
                                    <td><StatusBadge status={req.status} /></td>
                                    <td className="details-cell">
                                        {req.status === 'aprobado' && req.txId && (
                                            <span title={req.txId}>TxID: {req.txId.substring(0, 15)}...</span>
                                        )}
                                        {req.status === 'rechazado' && req.rejectionReason && (
                                            <span title={req.rejectionReason}>Motivo: {req.rejectionReason}</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MisRetiros;